module.exports = __webpack_public_path__ + "img/prize-05.f10385b9.png";